import { IonModal } from '@ionic/react';
import styled from 'styled-components';

import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const PageStyles = styled(OnboardingPage)`
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url(/assets/layout-own-ai-dominate/welcome/glowing-overlay.png)
      no-repeat center center / cover;
    z-index: -1;
    pointer-events: none;
  }

  .setting-up-title {
    margin: 32px auto 8px;
  }

  .setting-up-subtitle {
    margin-bottom: 20px;
  }

  .setting-up-user-reviews {
    margin: 24px 0 0;
  }
`;

export const Modal = styled(IonModal)`
  --width: 300px;
  --min-width: 250px;
  --height: auto;
  --border-radius: 28px;
  --background: linear-gradient(180deg, #161616 0%, #4c0808 100%);
  --box-shadow: 0px 0px 50px 0px rgba(0, 0, 0, 0.05);

  .major-turn-off-img {
    display: block;
    width: 190px;
    aspect-ratio: 1.82;
    margin: 0 auto 20px;
  }

  .modal-wrapper {
    padding: 24px;
  }
`;
